import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import {
  ModalOverlay,
  ModalContainer,
  CloseButton,
  ModalTitle,
  ModalSubtitle,
  Form,
  FormGroup,
  Label,
  Input,
  TextArea,
  SubmitButton,
  SuccessMessage,
} from "./ContactModalElements";
import { FaTimes } from "react-icons/fa";

// EmailJS Configuration
const EMAILJS_SERVICE_ID = "service_p9jawtb";
const EMAILJS_TEMPLATE_ID = "template_t648cc3";
const EMAILJS_PUBLIC_KEY = "yFQj6Vsdz-ltT7fo_";

const ContactModal = ({ isOpen, toggle }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError("");

    const templateParams = {
      to_email: "hello@esandev.in",
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone || "Not provided",
      company: formData.company || "Not provided",
      message: formData.message,
      subject: `New Inquiry from ${formData.name}${formData.company ? ` - ${formData.company}` : ""}`,
    };

    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        templateParams,
        EMAILJS_PUBLIC_KEY
      );

      setIsSuccess(true);
      setFormData({
        name: "",
        email: "",
        phone: "",
        company: "",
        message: "",
      });

      setTimeout(() => {
        setIsSuccess(false);
        toggle();
      }, 3000);
    } catch (err) {
      console.error("EmailJS Error:", err);
      setError("Failed to send message. Please try again or email us directly at hello@esandev.in");
    }

    setIsSubmitting(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      toggle();
    }
  };

  return (
    <ModalOverlay $isOpen={isOpen} onClick={handleOverlayClick}>
      <ModalContainer $isOpen={isOpen}>
        <CloseButton onClick={toggle}>
          <FaTimes />
        </CloseButton>

        {isSuccess ? (
          <SuccessMessage>
            <h3>Thank You!</h3>
            <p>Your message has been sent successfully. We'll get back to you soon!</p>
          </SuccessMessage>
        ) : (
          <>
            <ModalTitle>Get In Touch</ModalTitle>
            <ModalSubtitle>
              Fill out the form below and we'll get back to you as soon as possible.
            </ModalSubtitle>

            <Form onSubmit={handleSubmit}>
              <FormGroup>
                <Label htmlFor="name">Full Name *</Label>
                <Input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="John Doe"
                />
              </FormGroup>

              <FormGroup>
                <Label htmlFor="email">Email Address *</Label>
                <Input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="john@example.com"
                />
              </FormGroup>

              <FormGroup>
                <Label htmlFor="phone">Phone Number</Label>
                <Input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="+1 (555) 123-4567"
                />
              </FormGroup>

              <FormGroup>
                <Label htmlFor="company">Company Name</Label>
                <Input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Your Company"
                />
              </FormGroup>

              <FormGroup>
                <Label htmlFor="message">Project Details *</Label>
                <TextArea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Tell us about your project..."
                />
              </FormGroup>

              {error && (
                <p style={{ color: "#dc3545", fontSize: "14px", marginBottom: "15px" }}>
                  {error}
                </p>
              )}

              <SubmitButton type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Sending..." : "Send Message"}
              </SubmitButton>
            </Form>
          </>
        )}
      </ModalContainer>
    </ModalOverlay>
  );
};

export default ContactModal;
